import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DiaryForm } from "../models/trial-diary-form/diary-form.model";
import { DiaryFormSummary } from "../models/trial-diary-form/diary-form-summary.model";
import { CreateDiaryFormRequest } from "../models/trial-diary-form/create-diary-form-request.model";

@Injectable({
  providedIn: 'root'
})
export class DiaryFormService {

  private readonly ENDPOINT = '/DiaryForm/'
  constructor(private http: HttpClient) {
  }

  private apiUrl() {
    return environment.apiUrl + this.ENDPOINT;
  }

  enable(trialId: string) {
    return this.http.put(environment.apiUrl + '/diaryform/' + trialId + '/enable', {});
  }

  disable(trialId: string) {
    return this.http.put(environment.apiUrl + '/diaryform/' + trialId + '/disable', {});
  }

  list(trialId: string): Observable<DiaryFormSummary[]> {
    return this.http.get<DiaryFormSummary[]>(this.apiUrl() + 'trial/' + trialId);
  }

  create(trialId: string, request: CreateDiaryFormRequest): Observable<DiaryFormSummary> {
    return this.http.post<DiaryFormSummary>(this.apiUrl() + 'trial/' + trialId, request);
  }

  saveById(formId: string, diaryForm: DiaryForm): Observable<DiaryForm> {
    let i = 0;
    diaryForm.elements.forEach(element => {
      element.orderIndex = i;
      i++;

      if (element.options && element.options.length > 0) {
        let j = 0;
        element.options.forEach(option => {
          option.orderIndex = j;
          j++;
        });
      }
    });

    if (diaryForm.rules && diaryForm.rules.length > 0) {
      diaryForm.rules.forEach(rule => {
        delete rule.expressions;
      });
    }

    return this.http.put<DiaryForm>(this.apiUrl() + formId, diaryForm).pipe(
      map(response => {
        if (response.elements && Array.isArray(response.elements)) {
          response.elements = response.elements.sort((a, b) => a.orderIndex - b.orderIndex);
          response.elements.forEach(element => {
            if (element.options && Array.isArray(element.options)) {
              element.options = element.options.sort((a, b) => a.orderIndex - b.orderIndex);
            }
          });
        }
        return new DiaryForm(response);
      })
    );
  }

  delete(formId: string): Observable<void> {
    return this.http.delete<void>(this.apiUrl() + formId);
  }

  getById(formId: string): Observable<DiaryForm> {
    return this.http.get<any>(this.apiUrl() + formId)
      .pipe(
        map(response => {
          if (response.elements && Array.isArray(response.elements)) {
            response.elements = response.elements.sort((a, b) => a.orderIndex - b.orderIndex);
            response.elements.forEach(element => {
              if (element.options && Array.isArray(element.options)) {
                element.options = element.options.sort((a, b) => a.orderIndex - b.orderIndex);
              }
            });
          }
          return new DiaryForm(response);
        })
      );
  }
}
